// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-QAhnh{display:flex;align-items:center;margin-top:15px}`, "",{"version":3,"sources":["webpack://./src/components/error/NoCamera/nocamera.module.scss"],"names":[],"mappings":"AAAA,iBACI,YAAA,CACA,kBAAA,CACA,eAAA","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    margin-top: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container-QAhnh`
};
export default ___CSS_LOADER_EXPORT___;
